import { render } from "./Repackage_add.vue?vue&type=template&id=01ec8868&scoped=true"
import script from "./Repackage_add.vue?vue&type=script&lang=js"
export * from "./Repackage_add.vue?vue&type=script&lang=js"

import "./Repackage_add.vue?vue&type=style&index=0&id=01ec8868&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ec8868"]])

export default __exports__